import { saveAs } from 'file-saver';
import { yearOptions } from './utils';

export const content = [
  {
    label: 'Εξουσιοδότηση Αίτησης Ένταξης',
    fileCode: 'benApplAuthor',
    id: 'benApplAuthor',
    fileLimit: 10,
    required: true,
    // multiple: true
  },
  {
    label: 'Έγγραφα Ιδιοκτησιακού Καθεστώτος',
    fileCode: 'benPropStatus',
    id: 'benPropStatus',
    fileLimit: 10,
    required: true,
    multiple: true,
  },
  {
    label: 'Νομιμοποιητικά Έγγραφα Κτιρίου/ων',
    fileCode: 'benBuildLegal',
    id: 'benBuildLegal',
    fileLimit: 10,
    required: true,
    multiple: true,
  },
  {
    label: 'Βεβαίωση Μη Ριζικής Ανακαίνισης',
    fileCode: 'benRespDeclar',
    id: 'benRespDeclar',
    fileLimit: 10,
    required: true,
  },
  {
    label: 'Δελτίο Πρωτοβάθμιου Προσεισμικού Ελέγχου',
    fileCode: 'benPrimEarth',
    id: 'benPrimEarth',
    fileLimit: 10,
    required: true,
  },
  {
    label: 'Τεχνική Μελέτη',
    fileCode: 'benTechStudy',
    id: 'benTechStudy',
    fileLimit: 10,
    required: true,
  },
  {
    label: 'Τεκμηρίωση Αρμοδιότητας Υποβολής Αίτησης Ένταξης',
    fileCode: 'benCompSub',
    id: 'benCompSub',
    fileLimit: 10,
    required: true,
  },
  {
    label: 'Απόφαση Υποψηφίου Δικαιούχου Αίτησης Ένταξης',
    fileCode: 'benDecision',
    id: 'benDecision',
    fileLimit: 10,
    required: true,
  },
  {
    label: 'ΣΕΑΚ',
    fileCode: 'benSeak',
    id: 'benSeak',
    fileLimit: 10,
    required: true,
  },
];

export const content_pea = [
  {
    label: '1ο Πιστοποιητικό Ενεργειακής Απόδοσης',
    fileCode: 'benFirstPea',
    id: 'benFirstPea',
    fileLimit: 10,
    required: true,
  },
];

export const formFields = [
  {
    label: 'Αρ. Πρωτοκόλλου ΠΕΑ',
    type: 'text',
    name: 'prclNumber',
    id: 'prclNumber',
    size: 'large',
    placeholder: 'Εισάγετε Αριθμό',
    span: 6,
    asterisk: false,
    rules: [{ required: true, message: 'Το πεδίο είναι υποχρεωτικό' }],
  },
  {
    label: 'Κωδικός Ασφαλείας ΠΕΑ',
    type: 'text',
    name: 'secCode',
    id: 'secCode',
    size: 'large',
    placeholder: 'Εισάγετε Κωδικό',
    span: 7,
    asterisk: false,
    rules: [{ required: true, message: 'Το πεδίο είναι υποχρεωτικό' }],
  },
  {
    label: 'Έτος ΠΕΑ',
    type: 'select',
    name: 'certificationYear',
    id: 'certificationYear',
    size: 'medium',
    placeholder: 'Επιλέξτε Έτος',
    span: 5,
    asterisk: false,
    className: 'year',
    allowClear: true,
    options: yearOptions,
    rules: [{ required: true, message: 'Το πεδίο είναι υποχρεωτικό' }],
  },
];

export const formFields2 = [
  {
    label: 'Υπολ. Ετήσιας Κατανάλωσης Πρωτ. Ενέργειας',
    type: 'text',
    name: 'energyConsumption',
    id: 'energyConsumption',
    size: 'large',
    placeholder: '-',
    span: 9,
    disabled: true,
  },
  {
    label: 'Υπολ. Ετήσιας Εκπομπής Co2',
    type: 'text',
    name: 'reductionCo2',
    id: 'reductionCo2',
    size: 'large',
    placeholder: '-',
    span: 9,
    asterisk: false,
    disabled: true,
  },
];

export const content_optional = [
  {
    label: 'Τεκμηρίωση κάλυψης Υπερβαίνοντος Ποσού',
    fileCode: 'benCoverageDoc',
    id: 'benCoverageDoc',
    fileLimit: 10,
    required: false,
  },
  {
    label: 'Άλλο',
    fileCode: 'benOther',
    id: 'benOther',
    fileLimit: 10,
    required: false,
  },
  {
    label: 'Πρόσθετα Αρχεία',
    fileCode: 'otherDocs',
    id: 'otherDocs',
    fileLimit: 10,
    multiple: true,
    required: false,
  },
];
